/* globals jQuery */
/* eslint-disable @wordpress/no-global-event-listener */

jQuery( $ => {
	const $window = $( window );
	const $document = $( document );
	const $body = $( 'body' );

	// =========================
	// ! Utilities
	// =========================

	function setFlagClass( element, prefix, value ) {
		const classNames = [ ...element.classList ];

		classNames.forEach( className => {
			if ( className.indexOf( prefix ) === 0 ) {
				element.classList.remove( className );
			}
		} );

		if ( value ) {
			element.classList.add( `${ prefix }-${ value }` );
		}
	}

	// =========================
	// ! Supports Flagging
	// =========================

	$document
		.on( 'touchstart', function() {
			$body.removeClass( 'notouch' ).addClass( 'touch' );
		} )
		.on( 'mousedown', function() {
			$body.addClass( 'using-mouse' );
		} )
		.on( 'keydown', function() {
			$body.removeClass( 'using-mouse' );
		} );

	// =========================
	// ! External Link Enforcement
	// =========================

	$( 'a[href^="http"]' ).each( function() {
		if ( this.target ) {
			return;
		}

		if ( this.href.indexOf( location.origin ) !== 0 ) {
			this.target = '_blank';
		}
	} );

	// =========================
	// ! Toggle Buttons
	// =========================

	function toggleElement( target, toggle ) {
		if ( ! target ) {
			return false;
		}

		const $target = $( document.getElementById( target ) );
		if ( $target.length === 0 || ! $target.hasClass( 'js-toggleable' ) ) {
			return false;
		}

		const $toggles = $( `a[href="#${ target }"], [data-toggle="${ target }"]` );

		const className = `show-${ target }`;
		if ( typeof toggle === 'undefined' ) {
			toggle = ! $body.hasClass( className );
		}

		if ( toggle ) {
			$body.addClass( className ).trigger( `toggle:${ target }:on` );
			$target.addClass( 'is-open' );
			$toggles.addClass( 'is-active' );
		} else {
			$body.removeClass( className ).trigger( `toggle:${ target }:off` );
			$target.removeClass( 'is-open' );
			$toggles.removeClass( 'is-active' );
		}

		return true;
	}

	$body.on( 'click', '.js-toggle, [href^="#"], [rel="toggle"], [data-toggle]', function( e ) {
		const target = $( this ).data( 'toggle' ) || $( this ).attr( 'href' ).replace( '#', '' );

		if ( toggleElement( target ) && this.tagName.toLowerCase() === 'a' ) {
			e.preventDefault();
		}
	} );

	$body.on( 'click', '.js-close', function( e ) {
		e.preventDefault();

		const target = $( this ).parents( '.is-open' ).first().attr( 'id' );

		toggleElement( target, false );
	} );

	// =========================
	// ! Intersection Observers
	// =========================

	if ( typeof IntersectionObserver !== 'undefined' ) {
		const stickyObserver = new IntersectionObserver( ( [ e ] ) => {
			e.target.classList.toggle( 'is-stickied', e.intersectionRatio < 1 );
		}, {
			threshold: [ 1 ],
			rootMargin: '0% 0% 100% 0%',
		} );

		$( '.nao-page-title, .nao-section__header' ).addClass( 'js-sticky' );

		$( '.js-sticky' ).each( function() {
			stickyObserver.observe( this );
		} );
	}

	// =========================
	// ! Menu Toggling
	// =========================

	$( '.nao-header .sub-menu-wrapper.depth-0' ).prepend( '<button class="menu-close">Close</button>' );

	const $menuItems = $( '.nao-header .menu-item-has-children.depth-0' ).children( 'a, button' );
	$menuItems.click( function( e ) {
		e.preventDefault();

		const $submenu = $( this ).siblings( '.sub-menu-wrapper' );
		if ( $( this ).toggleClass( 'is-active' ).hasClass( 'is-active' ) ) {
			$( '.sub-menu-wrapper' ).removeClass( 'is-open' );
			$menuItems.not( this ).removeClass( 'is-active' );
			$submenu.addClass( 'is-open' );
		} else {
			$submenu.removeClass( 'is-open' );
		}
	} );

	$( '.menu-close' ).click( function() {
		$( this ).parents( '.sub-menu-wrapper' ).removeClass( 'is-open' ).siblings( 'a, button' ).removeClass( 'is-active' );
	} );

	// =========================
	// ! Sticky Banner Poster
	// =========================

	function setScrollTop() {
		document.documentElement.style.setProperty( '--scroll-top', window.scrollY );
	}

	window.addEventListener( 'scroll', setScrollTop );
	setScrollTop();

	// =========================
	// ! Excerpt Handling
	// =========================

	$document.on( 'click', '.nao-excerpt__toggle', function() {
		$( this ).parents( '.nao-excerpt' ).toggleClass( 'show-details' );
	} );

	// =========================
	// ! Accordion
	// =========================

	$document.on( 'click', '.js-accordion-toggle', function() {
		const $parent = $( this ).closest( '.js-accordion' );
		const $group = $parent.closest( '.js-accordion-group' );
		const $content = $parent.children( '.js-accordion-content' ).first();

		let openLabel = $( this ).data( 'label' ) || null;
		const closeLabel = $( this ).data( 'alt-label' ) || openLabel;

		if ( ! openLabel && closeLabel ) {
			openLabel = $( this ).text();
			$( this ).data( 'label', openLabel );
		}

		$parent.toggleClass( 'is-open' );
		if ( $parent.hasClass( 'is-open' ) ) {
			if ( closeLabel ) {
				$( this ).text( closeLabel );
			}
			$content.addClass( 'open' ).stop().hide().animate( { height: 'toggle' }, () => {
				$content.attr( 'style', '' );
			} );
		} else {
			if ( openLabel ) {
				$( this ).text( openLabel );
			}
			$content.stop().show().animate( { height: 'toggle' }, function() {
				$( this ).attr( 'style', '' ).removeClass( 'open' );
			} );
		}
	} );

	// Add classes to accordion blocks automatically
	$( '.nao-accordion-group, .nao-profile-group' ).addClass( 'js-accordion-group' );
	$( '.nao-accordion, .nao-profile' ).addClass( 'js-accordion' );
	$( '.nao-accordion__header, .nao-profile__toggle' ).addClass( 'js-accordion-toggle' );
	$( '.nao-accordion__content, .nao-profile__content' ).addClass( 'js-accordion-content' );

	$( window ).on( 'hashchange', function() {
		const target = window.location.hash;

		if ( target.length > 1 && $( target ).hasClass( 'js-accordion' ) ) {
			$( target ).find( '.js-accordion-content' ).trigger( 'click' );
		}
	} ).trigger( 'hashchange' );

	// =========================
	// ! Tab Set
	// =========================

	$document.on( 'click', '.js-tab-trigger', function( e ) {
		e.preventDefault();

		const $toggle = $( this );
		const elements = $toggle.data( 'tabsetData' );

		let $target, $group, $siblings, $targetSiblings;
		if ( elements ) {
			( { $target, $group, $siblings, $targetSiblings } = elements );
		} else {
			$target = $( $toggle.attr( 'href' ) );
			$group = $target.parents( '.js-tab-set' );
			$siblings = $group.find( '.js-tab-trigger' ).not( $toggle );
			$targetSiblings = $group.find( '.js-tab' ).not( $target );

			$toggle.data( 'tabsetData', { $target, $group, $siblings, $targetSiblings } );
		}

		$toggle.addClass( 'is-active' );
		$siblings.removeClass( 'is-active' );

		const $current = $targetSiblings.filter( '.is-open' );

		if ( $current.length === 0 ) {
			$target.stop().fadeIn().addClass( 'is-open' );
		}

		if ( $current.is( $target ) ) {
			return;
		}

		$current.stop().fadeOut( function() {
			$current.removeClass( 'is-open' );
			$target.stop().fadeIn().addClass( 'is-open' );
		} );
	} );

	// Add classes to tab/tabset blocks automatically
	$( '.nao-tab-set' ).addClass( 'js-tab-set' );
	$( '.nao-tab-set__nav-item' ).addClass( 'js-tab-trigger' );
	$( '.nao-tab' ).addClass( 'js-tab' );

	$( window ).on( 'hashchange', function() {
		const target = window.location.hash;

		if ( target.length > 1 && $( target ).hasClass( 'js-tab' ) ) {
			$( target ).find( '.js-tab-trigger' ).trigger( 'click' );
		}
	} ).trigger( 'hashchange' );

	// =========================
	// ! Load Results Handling
	// =========================

	const $content = $( '#index-content' );
	$document.on( 'click', '.nao-pagination__link.is-more', function() {
		const url = $( this ).data( 'url' );
		$content.addClass( 'loading' );

		$.ajax( {
			url,
			data: {
				ajax: true,
			},
			dataType: 'html',
			success( html ) {
				const $newContent = $( `<div>${ html }</div>` ).find( '#index-content' );
				$content.find( '.nao-pagination' ).remove();
				$content.append( $newContent.contents() );
			},
			complete() {
				$content.removeClass( 'loading' );
			},
		} );
	} );

	// =========================
	// ! VH Hack
	// =========================

	function setVH() {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty( '--vh', `${ vh }px` );
	}

	window.addEventListener( 'resize', setVH );
	setVH();

	// =========================
	// ! Initialize Stuff
	// =========================

	// Open accordions marked auto-open
	$( '.js-accordion.auto-open' ).addClass( 'is-open' ).find( '.js-accordion-content' ).addClass( 'open' );

	// Open first tab in a set
	$( '.js-tab-set' ).each( function() {
		$( this ).find( '.js-tab-trigger' ).first().addClass( 'is-active' );
		$( this ).find( '.js-tab' ).first().addClass( 'is-open' );
	} );

	$body.addClass( 'ready' );
} );
